import React from 'react';

export const sceneOneMeta = {
  id: 'mulberry-bird',
  title: '場景一｜看到一隻鳥正在吃桑椹',
  excerpt: '在生態自然農場，看見鳥吃桑椹，才明白土地是活著的，生命不是只屬於人。',
};

const SceneOneMulberryBird: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneOneMeta.title}</h2>
    <p>那一天，我在生態自然農場看到一隻鳥，正在吃桑椹。</p>
    <p>那一刻，我沒有覺得可惜，反而突然明白：為什麼生態農業這麼困難。</p>
    <p>因為你不是在跟市場競爭，你是在跟「生命」共存。</p>
    <p>鳥會來，蟲會來，果實本來就不只屬於人。</p>
    <p>那一刻我也明白：這片土地是活著的。</p>
    <p>而我們的問題是：我們活著，卻沒有真正活著。</p>
    <p>所以，森林學校存在的意義，不是教你怎麼種得更好，而是帶你回到這一刻。</p>
    <blockquote>看見一隻鳥，吃一顆果實，然後，停一下。</blockquote>
    <p>問你自己：你現在，是在「存在」，還是在「活著」？</p>
  </article>
);

export default SceneOneMulberryBird;
